export default IconArcheryArrow => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-archery-arrow" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M14 7v3h3l3 -3h-3v-3z" />
  <path d="M14 10l-9 9" />
  <path d="M5 15v4h4" />
</svg>`;